module.exports = __webpack_public_path__ + "static/media/double-chevron-up.8fed4320.svg";